<template>
  <CRow class="mx-1">
    <CCol col="10">
      <b-form-group label="Bulan - tahun" label-for="bulanTahun" class="my-0">
        <date-picker
          id="bulanTahun"
          type="month"
          format="MMMM - YYYY"
          style="width: 100%"
          v-model="filter.bulanTahun"
        ></date-picker>
      </b-form-group>
    </CCol>
    <CCol col="2" style="margin-bottom: 2px">
      <div class="w-100 h-100 d-flex align-items-end">
        <b-button
          variant="danger"
          style=""
          class="d-block w-100"
          v-c-tooltip.hover.click="'Reset'"
          @click="reset()"
          >Reset</b-button
        >
      </div>
    </CCol>
    <CCol col="12" class="mt-1 mb-2"><hr /></CCol>
    <CCol col="12">
      <CDataTable
        :items="items"
        :fields="fields"
        responsive
        sorter
        column-filter
        hover
        show-empty
        :loading="loading"
        @update:column-filter-value="onFilter($event)"
      >
        <template #tanggalNonAktif-filter>
          <date-picker
            style="width: 100%"
            v-model="filter.tanggalNonAktif"
            format="DD MMMM YYYY"
            required
          ></date-picker>
        </template>
        <template #statusPerjanjianAktif-filter>
          <b-form-select
            v-model="filter.statusPerjanjianAktif"
            :options="optionsStatusPerjanjianAktif"
          ></b-form-select>
        </template>
        <template #statusPerjanjianAktif="{ item }">
          <td>{{ item.namaStatusPerjanjianAktif }}</td>
        </template>
        <template #tanggalNonAktif="{ item }">
          <td>{{ item.namaTanggalNonAktif }}</td>
        </template>
        <template #Actions="{ item }">
          <td>
            <b-button
              variant="warning"
              class="mr-1"
              v-c-tooltip.hover.click="'Edit Data'"
              @click="editData(item)"
                :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
              ><CIcon name="cil-pencil" />{{ item.actions }}</b-button
            >
            <!-- <b-button
                variant="info"
                class="mr-1"
                v-c-tooltip.hover.click="'Detail'"
                v-b-modal.modal-detail
                @click="(data = item), (detail = !detail)"
                :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                ><CIcon name="cil-info" />{{ item.actions }}</b-button
              > -->
          </td>
        </template>
      </CDataTable>
      <MyPagination
        :entriesaw="entriesaw"
        :entriesak="entriesak"
        :totalRows="totalRows"
        :currentPage="currentPage"
        :perPage="perPage"
        @changeVar="changeVar"
      />
    </CCol>
  </CRow>
</template>

<script>
export default {
  components: {},
  name: "asuransi",
  data() {
    return {
      detail: false,
      data: {},
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: "Nama",
          _style: "max-width: 14%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "alamatKaryawan",
          label: "Alamat",
          _style: "max-width: 30%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaDivisi",
          label: "Divisi",
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "tanggalNonAktif",
          label: "Tanggal Non Aktif",
          _style: "max-width: 12%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaPosisi",
          label: "Posisi",
          _style: "max-width: 14%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "statusPerjanjianAktif",
          label: "Status",
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 5%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {
        statusPerjanjianAktif: null,
        bulanTahun: null,
        tanggalNonAktif: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusPerjanjianAktif: [
        { value: null, text: "pilih" },
        { value: "1", text: "Selesai /Habis Kontrak" },
        { value: "2", text: "Diberhentikan" },
        { value: "3", text: "Resign" },
        { value: "6", text: "Meninggal" },
        { value: "7", text: "Hilang / Tanpa Keterangan" },
        { value: "9", text: "Pensiun" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items
        ? this.items[this.items.length - 1].no
        : 0;
    },
  },
  mounted() {
    if(this.$store.state.role_aktif.kodeRole == 'super'){
      this.fields.splice(1, 0, { 
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      })
    }
    // this.getDatas();
    this.reset();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalNonAktif"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.statusPerjanjianAktif"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.bulanTahun"(newVal, oldVal) {
      const vm = this;
      if (newVal == null) {
        vm.reset();
      } else if (newVal != oldVal) {
        vm.filter.bulan = vm.$moment(newVal).format("MM");
        vm.filter.tahun = vm.$moment(newVal).format("YYYY");
        vm.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      console.log(vm.filter);
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listNonAktif = await vm.$axios.post(
        "dataKaryawan/listDataKaryawanTidakAktifPerHalaman",
        {
          ...vm.filter,
          tanggalAkhirKerja: vm.filter.tanggalNonAktif ? vm.$moment(vm.filter.tanggalNonAktif).format("YYYY-MM-DD") : null,
          halaman: vm.currentPage - 1,
          jumlah: vm.perPage,
        }
      );
      console.log("listNonAktif", listNonAktif);
      vm.items =
        listNonAktif.data.status == 200
          ? listNonAktif.data.data.map((x, idx) => {
              vm.optionsStatusPerjanjianAktif.forEach((item) => {
                if (x.statusPerjanjianAktif == item.value)
                  x.namaStatusPerjanjianAktif = item.text;
              });
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.dataKaryawanId, 
                namaMitra: x.namaMitra || ' - ',
                namaTanggalNonAktif: x.tanggalAkhirKerja ? vm.$moment(x.tanggalAkhirKerja).format("LL") : " - ",
              };
            })
          : [];
      vm.totalRows = Number(listNonAktif.data.count);
      vm.loading = false;
    },
    editData(data) {
      let vm = this;
      let routeData = vm.$router.resolve({
        name: "Detail Karyawan",
        query: { dataKaryawanId: data.dataKaryawanId },
      });
      window.open(routeData.href, "_blank");
    },
    reset() {
      this.filter.bulanTahun = null;
      this.filter.bulan = null;
      this.filter.tahun = null;
      this.getDatas();
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
